<div class="all-members-card">
  <div class="heading">
    <div class="heading-left">Family Members</div>
    <div class="heading-right" (click)="redirectToAddMembers()"> + <span>Add Members</span> </div>
  </div>


 <div class="loading-text" *ngIf="isLoading">
  
<div class=" skel"></div>
<div class=" skel"></div>
<div class=" skel"></div>

 </div>
<div class="members-grid" *ngIf="!isLoading">
    <div class="single-member-card" *ngFor="let member of family">
     <div class="profile-pic">
        <img src="../../../../assets/images/Wife.png" alt="" *ngIf="member.sex === 'F' && member.relationShipId.toLowerCase() === 'spouse'">
        <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="member.sex === 'M' && member.relationShipId.toLowerCase() === 'husband'">
        <img src="../../../../assets/images/Daughter.png" alt="" *ngIf="member.sex === 'F' && member.relationShipId.toLowerCase() === 'daughter'">
        <img src="../../../../assets/images/Son.png" alt="" *ngIf="member.sex === 'M' && member.relationShipId.toLowerCase() === 'son'">
        <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="member.sex === 'M' && member.relationShipId.toLowerCase() == 'self'">
        <img src="../../../../assets/images/Wife.png" alt="" *ngIf="member.sex === 'F' && member.relationShipId.toLowerCase() == 'self'">
      </div>

      <div class="details">
        <div class="member-name">{{ member.insuredName }}</div>
        <div class="member-about">
          {{ member.relationShipId | titlecase }} | {{ member.age }} Years | {{ member.sex  === 'M' ? 'Male' : 'Female' }}
        </div>
      </div>
    </div>
</div>

<div style="width: 579;
height: 28;
justify-content: space-between;
angle: 0 deg;
opacity: 1;
border-radius: 7px;
padding: 8px;
background: var(--quote-page-colour-colour-3-fcecdd, #FCECDD);
font-size: 10px;
font-weight: 600;
color: #121212;
text-align: center;
">Only Megastar DEs can add family members.</div>
</div>